import "./countObl.css";
import { isEmpty } from "lodash";
import { Tooltip } from "antd";

export const CountObl = ({
  totalObligations = 0,
  compliant = 0,
  partiallyCompliant = 0,
  nonCompliant = 0,
  na = 0,
  pending = 0,
  open = 0,
  assigned = 0,
  unassigned = 0,
  expiredCounters = {
    partially: 0,
    non: 0,
    na: 0,
    pending: 0,
    assigned: 0,
    unassigned: 0
  }
}) => {
  const maxCounter = !isEmpty(expiredCounters)
    ? `${Math.max(...Object.values(expiredCounters))} Expired`
    : "0 Expired";

  return (
    <div className="countobls" style={{ width: "28rem" }}>
      {" "}
      <div id="counters-container">
        <div id="count-obl-titles">
          <span className="home-counter-header count-obl-row">
            Total Obligations
          </span>
          <span className="home-counter-name count-obl-row">Compliant</span>
          <span className="home-counter-name count-obl-row">
            Partially Compliant
          </span>
          <span className="home-counter-name count-obl-row">Non-compliant</span>
          <span className="home-counter-name count-obl-row">Pending</span>
          <span className="home-counter-name count-obl-row">N/A</span>
          <span className="home-counter-header count-obl-row">
            Open Obligations
          </span>
          <span className="home-counter-name count-obl-row">Assigned</span>
          <span className="home-counter-name count-obl-row">Unassigned</span>
        </div>
        <div id="count-obl-expired">
          <div
            className={`home-counter-header home-counter-sum expired-sum invisible-sum count-obl-row`}
          >
            {" "}
            <div class="count-expired-tag">
              <span>{maxCounter}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum invisible-sum count-obl-row`}
          >
            <div class="count-expired-tag">
              <span>{maxCounter}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum count-obl-row ${
              expiredCounters?.partially ? "" : "invisible-sum"
            }`}
          >
            <div class="count-expired-tag">
              <span>{`${expiredCounters?.partially ?? 0} Expired`}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum count-obl-row ${
              expiredCounters?.non ? "" : "invisible-sum"
            }`}
          >
            <div class="count-expired-tag">
              <span>{`${expiredCounters?.non ?? 0} Expired`}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum count-obl-row ${
              expiredCounters?.pending ? "" : "invisible-sum"
            }`}
          >
            <div class="count-expired-tag">
              <span>{`${expiredCounters?.pending ?? 0} Expired`}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum count-obl-row ${
              expiredCounters?.na ? "invisible-sum" : "invisible-sum" //TO SHOW EXPIRED REMOVE THE FIRST "invisible-sum"
            }`}
          >
            <div class="count-expired-tag">
              <span> {`${expiredCounters?.na ?? 0} Expired`}</span>
            </div>
          </div>

          <div
            className={`home-counter-header home-counter-sum expired-sum invisible-sum count-obl-row`}
          >
            <div class="count-expired-tag">
              <span>{maxCounter}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum count-obl-row ${
              expiredCounters?.assigned ? "" : "invisible-sum"
            }`}
          >
            <div class="count-expired-tag">
              <span>{`${expiredCounters?.assigned ?? 0} Expired`}</span>
            </div>
          </div>
          <div
            className={`home-counter-sum expired-sum count-obl-row ${
              expiredCounters?.unassigned ? "" : "invisible-sum"
            }`}
          >
            <div class="count-expired-tag">
              <span> {`${expiredCounters?.unassigned ?? 0} Expired`}</span>
            </div>
          </div>
        </div>
        <div id="count-obl-counters">
          <span className="home-counter-header home-counter-sum count-obl-row">
            {totalObligations}
          </span>
          <span className="home-counter-sum count-obl-row">{compliant}</span>
          <span className="home-counter-sum count-obl-row">
            {partiallyCompliant}
          </span>
          <span className="home-counter-sum count-obl-row">{nonCompliant}</span>
          <span className="home-counter-sum count-obl-row">{pending}</span>
          <span className="home-counter-sum count-obl-row">{na}</span>
          <span className="home-counter-header home-counter-sum count-obl-row">
            {open}
          </span>
          <span className="home-counter-sum count-obl-row">{assigned}</span>
          <span className="home-counter-sum count-obl-row">
            {unassigned}
          </span>{" "}
        </div>
      </div>
    </div>
  );
};
